import Builder from '../Builder/Section';
export var FullscreenWrapper = Builder({
  tagName: 'article',
  className: 'full-screen__wrapper'
});
export var FullscreenMore = Builder({
  tagName: 'section',
  className: 'full-screen-more'
});
export var FullscreenMoreWrapper = Builder({
  tagName: 'article',
  className: 'full-screen-more__wrapper'
});
export var FullscreenMoreWrap = Builder({
  tagName: 'article',
  className: 'full-screen-more__wrap'
});
export var FullscreenMoreCover = Builder({
  className: 'full-screen-more--cover'
});
export var FullscreenCover = Builder({
  className: 'full-screen--cover'
});
export var Fullscreen = Builder({
  tagName: 'section',
  className: 'full-screen'
});